import { z } from 'zod'

import { dbEntitySchema } from './system'

export const daySettingSchema = dbEntitySchema.extend({
  organization: z.string(),
  venue: z.string(),
  date: z.date(),
  reservationRequestEnabled: z.boolean().nullish(),
  guestlistEnabledInternally: z.boolean().nullish(),
  guestlistEnabledExternally: z.boolean().nullish(),
  tallyEnabledInternally: z.boolean().nullish(),
  guestlistCutoff: z.string().optional().nullable().nullish(),
  timezone: z.string().optional().nullable().nullish(),
  //virtuals
  acceptingReservationRequests: z.boolean().nullish(),
  acceptingGuestlistInternally: z.boolean().nullish(),
  acceptingGuestlistExternally: z.boolean().nullish(),
  acceptingTallyInternally: z.boolean().nullish(),
})

export const daySettingPublicSchema = daySettingSchema.pick({
  id: true,
  venue: true,
  date: true,
  reservationRequestEnabled: true,
  acceptingReservationRequests: true,
  acceptingGuestlistExternally: true,
})

export const daySettingListQuerySchema = z.object({
  dateStart: z.coerce.number(),
  dateEnd: z.coerce.number(),
})

export const daySettingListResponseSchema = z.object({
  data: z.array(daySettingPublicSchema),
})

export const daySettingCreateArgsSchema = z.object({
  venueId: z.string(),
  date: z.date(),
})

export const daySettingUpdateByIdArgsSchema = z.object({
  applyToAll: z.boolean().optional().nullable(),
  reservationRequestEnabled: z.boolean().optional().nullable(),
  guestlistEnabledInternally: z.boolean().optional().nullable(),
  guestlistEnabledExternally: z.boolean().optional().nullable(),
  tallyEnabledInternally: z.boolean().optional().nullable(),
  guestlistCutoff: z.string().optional().nullable(),
  timezone: z.string().optional().nullable(),
})
